export interface ICoordinates {
  x: number;
  y: number;
}

interface IDeveloperRooms {
  roomTypeDisplay: string;
  price2From: string;
  offersUrl: string;
  roomType: string;
}

export interface IHouseStats {
  fromDeveloperPropsCountDisplay: string;
  fromDeveloperPropsCountUrl: string;
  fromDeveloperRooms: IDeveloperRooms[];
}

export interface IHouse {
  id: number;
  name: string;
  tooltipPoint: ICoordinates;
  polygonPath: string;
  houseInfo: string[];
  isEscrow: boolean;
  isReliable: boolean;
  isSalesStart: boolean;
  stats: IHouseStats | null;
}

export enum EGenplanInfrastructureCategory {
  /** Достопримечательность **/
  'Attraction' = 'attraction',
  /** Мед. учреждение **/
  'Clinic' = 'clinic',
  /** Магазин **/
  'Grocery' = 'grocery',
  /** Детский сад **/
  'Nursery' = 'nursery',
  /** Учебное заведение **/
  'School' = 'school',
}

export interface IGenplanInfrastructure {
  category: EGenplanInfrastructureCategory;
  tooltipPoint: ICoordinates;
  id: number;
  name: string;
}

export interface IGenplan {
  image: string;
  isHousesNamesEnabled: boolean;
  houses: IHouse[];
  genplanInfrastructure: IGenplanInfrastructure[];
}
